import { Fragment, useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { apiStatuses, errorMessage, jobsPerPage, landingPageContent, roleError, userNavigationActions } from '../../utils/constantData';
import { useDismissSampleTooltipMutation, useLogoutMutation, useSwitchToSampleModeMutation } from '../../../modules/authentication/slice/createAuthApiSlice';
import { selectCurrentUser, setAllRolesPermissions, setCredentials, setIsSuccessLogin, setRolePerCompany, setRolePermissionsPerJob, viewOTPComponent } from '../../../modules/authentication/slice/authSlice';
import { Button, Divider, message, Spin, Tooltip } from 'antd';
import { useCookies } from 'react-cookie';
import { Link, useNavigate } from 'react-router-dom';
import { setJobsListLength, setJobsFilter } from '../../../modules/viewJobs/slice/jobListSlice';
import ProfileImage from './profileImage';
import ModalBody from '../Modals/ModalBody';
import SendFeedbackForm from '../../../modules/ContactUsForm/components/SendFeedbackForm';
import ModalComponent from '../Modals/ModalComponent';
import ResponsiveDivider from './ResponsiveDivider';
import { selectCompanyData, setCompanyData } from '../../../modules/createJob/slice/companySlice';
import { NavLink, useLocation } from 'react-router-dom';
import './nav.scss';
import { setActiveTab, setBatchId, setIsAnimationReady, setJobTitle } from '../../../modules/createJob/slice/jobSlice';
import { tabs } from '../../utils/interfaces/createJobTabs';
import { getImageUrl } from '../../utils/functions/images';
import { setIsErrorJobs, setReportsFilters, setResetReports } from '../../../modules/reports/slice/reportsSlice';
import { useDemoMode } from '../../utils/customHooks/useDemoHook';
import navUserIcon from '../../assets/images/navUserIcon.svg';
import navSettingsIcon from '../../assets/images/navSettingsIcon.svg';
import navLogoutIcon from '../../assets/images/navLogoutIcon.svg';
import navLabIcon from '../../assets/images/navLabIcon.svg';
import navDemoModeIcon from '../../assets/images/navDemoModeIcon.svg';
import { WithTooltip } from '../tooltip.tsx/withTootip';
import { permissionsActions, Roles } from '../../utils/interfaces/AuthInterface';
import LabDimmedIcon from '../../assets/images/labDimmed.svg'
import searchIcon from '../../assets/images/Search.svg'
import searchMinimizedIcon from '../../assets/images/SearchMinimized.svg'
import useSampleDataStatus from '../../utils/customHooks/useSampleDataStatus';
import SearchResult from '../SearchResult';
import { usePermissions } from '../../utils/customHooks/usePermissions';
import myPageIcon from '../../assets/images/briefcase.svg'
import SettingsNotification from '../tooltip.tsx/SettingsNotification';
import { useDismissMyPageTooltipMutation } from '../../../modules/createJob/slice/candiddateApiSlice';
import { setAllKits, setSelectedTemplate } from '../../../modules/interview/slice/interviewSlice';
import { PlanTypes } from '../../utils/interfaces/planInterface';
import PlansModal from '../../../modules/settings/components/Plans/PlansModal';
import { selectIsClickingUpdatingPlan, selectPlansModalOpen, setIsClickingUpdatePlan, setPlansModalOpen } from '../../../modules/settings/slice/settingsSlice';
import { selectFromPage, setBookADemoOpen, setIseBook , setCurrentStepperStep} from '../../../modules/ContactUsForm/slice/contactusSlice';
import { analytics } from '../../utils/analytics';
import { logEvent } from 'firebase/analytics';
import { CTAType } from '../../utils/interfaces/landingPageFace';
import { setIsSubmittingSearch, setSearchCandidatesFilter } from '../../../modules/createJob/slice/candidateSlice';
import { SearchCandidatesSorting } from '../../utils/interfaces/candidatesListFace';
function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ')
}
export default function Nav({ isPublic }: { isPublic?: boolean }) {
  const { logOut, setting, myPage } = userNavigationActions
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [, setCookie] = useCookies(['isActive'])
  const user = useSelector(selectCurrentUser)
  const [logout, { isLoading, isSuccess }] = useLogoutMutation()
  const [burgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const insideRef = useRef<HTMLDivElement>(null);
  const exceptionRef = useRef<HTMLDivElement>(null);
  const searchRef = useRef<HTMLDivElement>(null);
  const togglerRef: any = useRef<HTMLDivElement>(null);
  const company = useSelector(selectCompanyData)
  const haveJobs = useSelector(selectCurrentUser)?.haveJobs
  const isPlanModalOpen = useSelector(selectPlansModalOpen)
  const isClickingUpdatePlan = useSelector(selectIsClickingUpdatingPlan)
  const { reports, searchCandidates, switchToDemo } = permissionsActions
  const { toggleMode, isDemoMode } = useDemoMode()
  const { preparingSampleData, isLoadingSampleData } = useSampleDataStatus()
  const [dismissSampleTooltip, { isSuccess: dismissSuccess, isLoading: dismissLoading, isError: dismissisError }] = useDismissSampleTooltipMutation()
  const [switchToSampleMode, { isError: switchError, isLoading: switchLoading, data: switchData }] = useSwitchToSampleModeMutation()
  const [dismissMyPageTooltip, { isSuccess: myPageSuccess, isLoading: myPageLoading, isError: myPageisError }] = useDismissMyPageTooltipMutation()
  const [isExpanded, setIsExpanded] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [showSearchResult, setShowSearchResult] = useState(true)
  const searchResultRef = useRef<HTMLDivElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const { hasAppPermission } = usePermissions()
  const location = useLocation();
  const fromPage = useSelector(selectFromPage);
  const landingContent = landingPageContent[location.pathname] || landingPageContent[fromPage]

  const handleFocus = () => {
    setShowSearchResult(true);
  };

  const handleBlur = () => {
    setTimeout(() => {
      if (!searchResultRef.current?.contains(document.activeElement)) {
        setShowSearchResult(false);
      }
    }, 150);
  };

  const handleResultMouseDown = (event: React.MouseEvent) => {
    event.preventDefault();
  };
  const handleSearchToggle = () => {
    setIsExpanded(!isExpanded);
  }
  const handleSearchInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchInput(e.target.value);
    if (!showSearchResult) {
      setShowSearchResult(true)
    }
  };

  useEffect(() => {
    if (isSuccess) {
      dispatch(setActiveTab(tabs.description))
      dispatch(setCompanyData({}))
      dispatch(setJobsListLength(0));
      dispatch(setJobsFilter({
        page: 1,
        jobsPerPage: jobsPerPage,
        sortBy: 'lastCreated',
        includeDrafts: true,
        shortVersion: true,
      }));
      dispatch(setReportsFilters({ page: 1, perPage: 10 }))
      dispatch(setRolePerCompany(null));
      dispatch(setRolePermissionsPerJob({ role: null, permissions: [] }))
      dispatch(setAllRolesPermissions(null))
      dispatch(viewOTPComponent(false));
      dispatch(setIsSuccessLogin(false))
      localStorage.removeItem('batchId');
      dispatch(setBatchId(null));
      dispatch(setResetReports());
      dispatch(setAllKits([]))
      dispatch(setSelectedTemplate(null))
      dispatch(setJobTitle(''))
      dispatch(setIsAnimationReady(false))
      setCookie('isActive', false, { path: '/' })
    }
  }, [isSuccess, dispatch, setCookie])

  useEffect(() => {
    if (isClickingUpdatePlan && !isPlanModalOpen) dispatch(setIsClickingUpdatePlan(false))
  }, [isClickingUpdatePlan, isPlanModalOpen, dispatch])

  const handleClick = async (name: string) => {
    if (name === logOut) {
      const data = await logout();
      if (data?.error) message.error(errorMessage, 5);
      else navigate('/');
    }
    if (name === setting) {
      dispatch(setSelectedTemplate(null))
      isDemoMode ? navigate('/settings/templates/email') : navigate('/settings/profile');
    }
  }

  const toggleBurgerMenu = useCallback((event: MouseEvent) => {
    const clickedInside = exceptionRef.current?.contains(event.target as Node) || searchRef.current?.contains(event.target as Node);
    const clickedToggler = togglerRef.current === event.target || togglerRef.current?.contains(event.target as Node);

    if ((!clickedInside && burgerMenuOpen) || clickedToggler) setBurgerMenuOpen(!burgerMenuOpen);
  }, [burgerMenuOpen]);

  const handleToggleModal = () => {
    setModalOpen(!modalOpen);
  }

  useEffect(() => {
    document.body.addEventListener('click', toggleBurgerMenu)

    return () => {
      document.body.removeEventListener('click', toggleBurgerMenu)
    }
  }, [toggleBurgerMenu]);

  useEffect(() => {
    if (dismissSuccess) {
      dispatch(setCredentials({ user: { ...user, isSampleTooltipDismissed: true } }))
    } else if (dismissisError) {
      message.error(errorMessage)
    }
    // eslint-disable-next-line
  }, [dismissSuccess, dismissisError, dispatch])

  useEffect(() => {
    if (switchData?.statusCode === apiStatuses.success) {
      toggleMode()
    } else if (switchData?.statusCode === apiStatuses.processingRequest) {
      navigate('/jobs')
      preparingSampleData()
    } else if (switchError) {
      message.error(errorMessage)
    }
    // eslint-disable-next-line
  }, [switchData, switchError])

  useEffect(() => {
    setIsExpanded(false);
    setSearchInput("");
  }, [location.pathname, location.search]);

  const handleSwitchToDemo = async () => {
    await switchToSampleMode(!isDemoMode);
  }

  const handleDismissDemoNotification = async () => {
    await dismissSampleTooltip();
  }

  useEffect(() => {
    if (myPageSuccess) {
      dispatch(setCredentials({ user: { ...user, isCareerTooltipDismissed: true } }));
    } else if (myPageisError) {
      message.error(errorMessage);
    }
    // eslint-disable-next-line
  }, [myPageSuccess, myPageisError, user?.isCareerTooltipDismissed]);

  const handleDismissMyPage = async () => {
    await dismissMyPageTooltip();
  };

  const openBookDemo = () => {
    dispatch(setCurrentStepperStep(0))
    dispatch(setIseBook(false))
    dispatch(setBookADemoOpen(true))
    logEvent(analytics, 'BookADemoBeforeForm')
    navigate('/book-demo')
  }

  return (
    <Disclosure as="nav" className="relative bg-gray-800 navbar">
      <div className="container flex items-center h-nav">
        <div className="flex items-center w-full flex-nowrap">
          <div className="min-w-fit me-4 md:me-6">
            <Link to='/jobs'>
              <img alt='PeopleCQ' src={getImageUrl('Logo')} className='hidden md:inline' />
              <img alt='PeopleCQ' src={getImageUrl('CQLogoSM')} className='inline md:hidden' />
            </Link>
          </div>
          <div className="flex items-center justify-end flex-grow">
            <div className='flex w-full' ref={insideRef}>
              <div ref={exceptionRef} className={`nav-actions h-screen-minus-nav lg:h-auto w-full bg-gray-800 px-3 lg:px-0 lg:flex flex-col lg:flex-row flex-wrap lg:flex-nowrap lg:justify-between absolute lg:static left-0 right-0 top-nav z-[1000] ${burgerMenuOpen ? 'flex' : 'hidden'}`}>
                {
                  isPublic ?
                    <>
                      <div className='lg:ml-auto'>
                        {(fromPage === '/' || location.pathname === '/') &&
                          <>
                        <Link to='/resources'><Button className='w-full lg:w-auto mb-3.5 lg:mb-0 btn-md border-0 lg:mx-4 px-3 text-gray-300'>Resources</Button></Link>
                          {/* <Link to='/pricing'><Button className='w-full lg:w-auto mb-3.5 lg:mb-0 btn-md border-0 lg:mx-4 px-3 text-gray-300'>Pricing</Button></Link> */}
                          <Link to='/subscription-plans'><Button className='w-full lg:w-auto mb-3.5 lg:mb-0 btn-md border-0 lg:mx-4 px-3 text-gray-300'>Subscription Plans</Button></Link> {/* for demo only */}
                        <Link to='/contact-us'><Button className='w-full lg:w-auto mb-3.5 lg:mb-0 btn-md border-0 lg:mx-4 px-3 text-gray-300'>Contact Us</Button></Link>
                        <div className={`${burgerMenuOpen ? 'inline-block' : 'hidden'} lg:inline-block`}><ResponsiveDivider /></div>
                          <Link to='/login'><Button className={`w-full lg:w-auto mb-3.5 lg:mb-0 btn-md border-0 lg:mx-4 px-3 text-gray-300 ${burgerMenuOpen ? 'inline-block' : 'hidden'} lg:inline-block`}>Sign in</Button></Link>
                          </>
                        }
                        {fromPage === '/' || location.pathname === '/' ? <Button className="w-full mr-6 text-white border-white lg:w-auto mb-3.5 lg:mb-0 btn btn-md" onClick={openBookDemo}>Book a demo</Button>
                          : landingContent?.cta?.includes(CTAType.Book) ?
                            <Button className="w-full mr-6 btn-primary btn-md text-white border-indigo-600 lg:w-auto mb-3.5 lg:mb-0" onClick={openBookDemo}>Book a demo</Button>
                            : <></>
                        }
                        {(landingContent?.cta?.includes(CTAType.Trial) || fromPage === '/') && <Link to='/signup'>
                          <Button className='w-full lg:w-auto mb-3.5 lg:mb-0 btn-primary btn-md text-white border-indigo-600'>Start your free trial</Button>
                        </Link>}
                      </div>
                    </>
                    :
                    <>
                      <div className='flex flex-wrap items-center justify-center w-full lg:w-auto lg:ms-6 lg:gap-4 lg:flex-nowrap'>
                        <div className='flex flex-col items-center justify-center w-full'>
                          <div ref={searchRef} className='relative flex items-center w-full my-5 lg:hidden'>
                            <div className='flex items-center w-full bg-gray-700 border border-gray-700 rounded-md'>
                              <span className='absolute inset-y-0 left-0 flex items-center pl-2'>
                                <img src={searchMinimizedIcon} alt='Search' className='w-5 h-5 cursor-pointer' />
                              </span>
                              <WithTooltip visible={!hasAppPermission(searchCandidates) && !!user?.company?.id} title={roleError} placement='bottom'>
                                <div>
                                  <input
                                    ref={inputRef}
                                    type='text'
                                    className={`w-full pl-10 text-white bg-transparent border-none outline-none ${!!user?.company?.id && !hasAppPermission(searchCandidates) ? "pointer-events-none lg:pointer-events-auto" : ''}`}
                                    value={searchInput}
                                    onChange={handleSearchInput}
                                    placeholder='Search candidates'
                                    maxLength={70}
                                    onFocus={handleFocus}
                                    onBlur={handleBlur}
                                    disabled={!!user?.company?.id && !hasAppPermission(searchCandidates)}
                                  />
                                </div>
                              </WithTooltip>
                            </div>
                            {searchInput && showSearchResult ?
                              <div ref={searchResultRef} onMouseDown={handleResultMouseDown} >
                                <SearchResult onResultClick={() => setShowSearchResult(false)} searchInput={searchInput} />
                              </div> : null}
                          </div>
                        </div>
                        <NavLink
                          to={haveJobs ? "/jobs" : "/generateJob"}
                          onClick={!haveJobs ? () => dispatch(setActiveTab(tabs.description)) : undefined}
                          className={({ isActive }) =>
                            `w-full lg:w-auto mb-3.5 lg:mb-0 ${isActive || location.pathname.includes("/generateJob") ? "active" : ""
                            }`
                          }
                        >
                          <Button
                            className={`w-full group btn-md border-0 px-3 hover:bg-gray-900 shadow-none`}
                            onClick={() => setBurgerMenuOpen(false)}
                          >
                            <span className="text-gray-300 navLinkText group-hover:text-white">Jobs</span>
                          </Button>
                        </NavLink>
                        <WithTooltip visible={!!user?.company?.id && !hasAppPermission(searchCandidates)} title={roleError} placement='bottom'>
                          <div className="w-full">
                            <NavLink
                              className={`w-full lg:w-auto mb-3.5 lg:mb-0 ${!!user?.company?.id && !hasAppPermission(searchCandidates) ? "pointer-events-none lg:pointer-events-auto" : ''}`}
                              to={"/search"}
                            >
                              <Button
                                className={`w-full group btn-md border-0 px-3 ${!!user?.company?.id && !hasAppPermission(searchCandidates) ? '' : 'hover:bg-gray-900'}  shadow-none`}
                                disabled={!!user?.company?.id && !hasAppPermission(searchCandidates)}
                                onClick={() => { setBurgerMenuOpen(false); dispatch(setSearchCandidatesFilter({ page: 1, perPage: 10, sortBy: SearchCandidatesSorting[0].value })) }}
                              >
                                <span className='text-gray-300 navLinkText group-hover:text-white'>Candidates</span>
                              </Button>
                            </NavLink>
                          </div>
                        </WithTooltip>
                        <WithTooltip visible={!hasAppPermission(reports) && !!user?.company?.id} title={roleError} placement='bottom'>
                          <div className="w-full">
                            <NavLink
                              className={`w-full lg:w-auto mb-3.5 lg:mb-0 ${!!user?.company?.id && !hasAppPermission(reports) ? "pointer-events-none lg:pointer-events-auto" : ''}`}
                              to={`/reports`}>
                              <Button
                                className={`w-full group btn-md border-0 px-3 ${!!user?.company?.id && !hasAppPermission(reports) ? '' : 'hover:bg-gray-900'} shadow-none`}
                                onClick={() => {
                                  setBurgerMenuOpen(false)
                                  dispatch(setIsErrorJobs(false))
                                  dispatch(setReportsFilters({ page: 1, perPage: 10 }))
                                }}
                                disabled={!!user?.company?.id && (!hasAppPermission(reports))}
                              >
                                <span className='text-gray-300 navLinkText group-hover:text-white'>Reports</span>
                              </Button>
                            </NavLink>
                          </div>
                        </WithTooltip>
                        <div className='w-full lg:hidden'><ResponsiveDivider /></div>
                      </div>
                      <div className='flex flex-wrap items-center w-full mt-auto mb-8 lg:w-auto md:ml-auto lg:mt-0 lg:mb-0 lg:flex-nowrap'>
                        {user?.adminRole === Roles.superAdmin ?
                          <>
                            <Button className='w-full p-0 mx-3 !text-gray-300 transition-none border-0 shadow-none lg:w-auto group' onClick={() => {
                              dispatch(setIsClickingUpdatePlan(true))
                              dispatch(setPlansModalOpen(true))
                            }} disabled={user?.plan?.id === PlanTypes.premium}>
                              <span className='group-hover:text-gray-400'>{user?.plan?.id === PlanTypes.free ? "Upgrade Now" : user?.plan?.id === PlanTypes.standard ? "Upgrade to Premium" : "Premium User"}</span>
                            </Button>
                            <Divider type='vertical' className='hidden h-6 border-gray-400 lg:inline-block' />
                          </>
                          : null
                        }
                        {
                          isClickingUpdatePlan ? <PlansModal /> : <PlansModal title={`You reached the ${user?.plan?.name} plan limit!`} subtitle={user?.plan?.id === PlanTypes.premium ? "" : `Upgrade your plan to ${user?.plan?.id === PlanTypes.free ? "Standard" : user?.plan?.id === PlanTypes.standard ? "Premium" : user?.plan?.id} and accelerate your hiring process`
                          } />
                        }
                        <Button className='w-full p-0 mx-3 text-gray-300 transition-none border-0 shadow-none lg:w-auto group' onClick={handleToggleModal}>
                          <svg className='inline mr-2' width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className='group-hover:stroke-gray-400' d="M6.66667 8.3335H6.675M10 8.3335H10.0083M13.3333 8.3335H13.3417M7.5 13.3335H4.16667C3.24619 13.3335 2.5 12.5873 2.5 11.6668V5.00016C2.5 4.07969 3.24619 3.3335 4.16667 3.3335H15.8333C16.7538 3.3335 17.5 4.07969 17.5 5.00016V11.6668C17.5 12.5873 16.7538 13.3335 15.8333 13.3335H11.6667L7.5 17.5002V13.3335Z" stroke="#D1D5DB" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                          <span className='group-hover:text-gray-400'>Send Feedback</span>
                        </Button>
                      </div>
                      <ModalComponent
                        visibleModal={modalOpen}
                        handleCloseModal={handleToggleModal}
                        content={
                          <ModalBody
                            icon={getImageUrl('chatCircle')}
                            title='Send Feedback'
                            subtitle='We love feedback! Share your thoughts and help us improve.'
                          >
                            <SendFeedbackForm afterSubmit={handleToggleModal} />
                          </ModalBody>
                        }
                      />
                      <div className="relative items-center hidden lg:flex ">
                        <div className={`h-8  flex transition-all duration-300 ease-in-out ${isExpanded
                          ? 'w-80 border p-2 border-gray-700 bg-gray-700 rounded-md mx-3'
                          : 'w-9 border-none p-0 bg-transparent'
                          }`}
                        >
                          <WithTooltip visible={!hasAppPermission(searchCandidates) && !!user?.company?.id} title={roleError} placement='bottom' >
                            <div>
                              <Button className={`left-0 flex items-center w-5 h-5 p-0 border-none`} disabled={!user?.company?.id || !haveJobs || !hasAppPermission(searchCandidates)}>
                                <img src={isExpanded ? searchMinimizedIcon : searchIcon} alt="Search" className={`${isExpanded ? 'mb-1.5' : 'mt-3'}`} onClick={handleSearchToggle} />
                              </Button>
                            </div>
                          </WithTooltip>

                          {isExpanded && (
                            <>
                              <input
                                ref={inputRef}
                                type="text"
                                className="w-full pr-2 text-white bg-transparent border-none outline-none "
                                value={searchInput}
                                onChange={handleSearchInput}
                                placeholder='Search candidates'
                                maxLength={70}
                                onFocus={handleFocus}
                                onBlur={handleBlur}
                                onKeyDown={(e) => {
                                  if (e.key === 'Enter') {
                                    setShowSearchResult(false);
                                    if (searchInput) navigate(`/search?query=${searchInput}`);
                                    dispatch(setIsSubmittingSearch(true))
                                    setIsExpanded(false);
                                    setSearchInput("");
                                  }
                                }}
                              />
                              {searchInput && showSearchResult ? <div ref={searchResultRef} onMouseDown={handleResultMouseDown}><SearchResult onResultClick={() => setShowSearchResult(false)} searchInput={searchInput} className='mx-3' /></div> : null}
                            </>
                          )}
                        </div>
                      </div>
                    </>
                }
              </div>
            </div>
            {isPublic ? <Link to='/login'><Button className={`w-full px-3 text-sm font-medium text-gray-300 border-0 lg:w-auto lg:mb-0 btn-md lg:mx-4 lg:hidden ${burgerMenuOpen ? 'hidden' : 'inline-block'}`}>Sign in</Button></Link> : null}
            <Button ref={togglerRef} type='link' className='px-2 lg:hidden min-w-max'><img src={!burgerMenuOpen ? getImageUrl('burgerMenu') : getImageUrl('burgerMenuX')} alt="Menu" /></Button>
            {!isPublic &&
              <>
                <Tooltip
                  trigger={"click"}
                  placement='bottom'
                  title={<SettingsNotification
                    maxWidth="max-w-48"
                    isLoading={myPageLoading}
                    text={
                      <>
                        <span className='margin'>A public Career Page was created.<br />
                        </span>You can always check it<br />
                        through the link in this menu</>}
                    onClickFunction={handleDismissMyPage}
                  />}
                  overlayInnerStyle={{ padding: '0', backgroundColor: 'transparent' }}
                  overlayClassName={`text-xs font-normal before:[&_.ant-tooltip-arrow]:bg-yellow-50`}
                  open={!isDemoMode && !user?.isCareerTooltipDismissed && !!user?.company?.id}
                >
                  <Menu as="div" className="relative ml-3">
                    <div className='flex flex-nowrap'>
                      <Menu.Button className="flex items-center max-w-xs text-sm bg-gray-800 rounded-full focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800">
                        <span className="sr-only">Open user menu</span>
                        {user && <ProfileImage name={`${user?.firstName} ${user?.lastName}`} />}
                      </Menu.Button>
                      <Tooltip
                        trigger={"click"}
                        open={isDemoMode && !user?.isSampleTooltipDismissed}
                        placement='bottom'
                        title={
                          <div className="relative">
                            <div className="bg-yellow-50 py-2 px-2.5 rounded-md shadow-lg">
                              <div className="flex flex-col items-center">
                                <div className="text-center">
                                  <p className="mb-1 text-sm text-yellow-800 max-w-40">
                                    You can always switch back to your account through the profile icon
                                    <br /><br />
                                    All changes applied in Demo Mode will not affect your account
                                  </p>
                                  <span onClick={handleDismissDemoNotification} className="p-0 m-0 text-xs font-bold text-yellow-800 underline cursor-pointer font-weight-700 hover:text-yellow-800">{dismissLoading ? <Spin size='small' /> : 'Dismiss'}</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        }
                        overlayInnerStyle={{ padding: '0', backgroundColor: 'transparent' }}
                        overlayClassName={`text-xs font-normal before:[&_.ant-tooltip-arrow]:bg-yellow-50`}
                      >
                        <img className={`transition absolute opacity-0 pointer-events-none left-0 translate-x-5 ${isDemoMode ? 'opacity-100 !translate-x-3' : ''}`} src={navDemoModeIcon} alt='Demo mode' />
                      </Tooltip>
                    </div>
                    <Transition
                      as={Fragment}
                      enter="transition ease-out duration-100"
                      enterFrom="transform opacity-0 scale-95"
                      enterTo="transform opacity-100 scale-100"
                      leave="transition ease-in duration-75"
                      leaveFrom="transform opacity-100 scale-100"
                      leaveTo="transform opacity-0 scale-95"
                    >
                      <Menu.Items className="absolute right-0 z-[1000] w-48 px-3 py-1 mt-2 origin-top-right bg-white rounded-md shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
                        <Menu.Item>
                          <WithTooltip
                            visible={!hasAppPermission(switchToDemo) && !isDemoMode && !!user?.company?.id}
                            title={roleError}
                            placement='left'
                          >
                            <div
                              onClick={((!hasAppPermission(switchToDemo) && !isDemoMode && !!user?.company?.id) || isLoadingSampleData ? () => { } : handleSwitchToDemo)}
                              className={classNames(
                                (!hasAppPermission(switchToDemo) && !isDemoMode && !!user?.company?.id) || isLoadingSampleData ? 'cursor-not-allowed text-gray-400' : 'text-gray-700 cursor-pointer',
                                'flex flex-nowrap items-start px-4 py-2 text-sm cu',
                                switchLoading ? 'cursor-wait' : ""
                              )}
                            >
                              <img src={isDemoMode ? navUserIcon : (!hasAppPermission(switchToDemo) && !!user?.company?.id
                                ? LabDimmedIcon : navLabIcon)} className='inline me-2' alt='Settings' />
                              <span>Switch to {isDemoMode ? 'Active' : 'Demo'} Mode</span>
                            </div>
                          </WithTooltip>
                        </Menu.Item>
                        <Divider className='m-0 border-gray-200' />
                        <Menu.Item disabled={!user?.company?.id} >
                          <p
                            onClick={() => navigate(`/company/${company?.name}`)}
                            className={classNames(
                              (!!user?.company?.id) ? 'text-gray-700 cursor-pointer' : 'cursor-not-allowed text-gray-400',
                              'flex flex-nowrap whitespace-nowrap items-start px-4 py-2 text-sm',
                            )}
                          >
                            <img src={myPageIcon} className={`inline ${!user?.company?.id ? 'opacity-30' : ''} me-2 btn-icon`} alt='myPage' />{myPage}
                          </p>
                        </Menu.Item>
                        <Divider className='m-0 border-gray-200' />
                        <Menu.Item>
                          <p
                            onClick={() => handleClick(setting)}
                            className={classNames(
                              'block px-4 py-2 text-sm text-gray-700 cursor-pointer cu',
                              isLoading ? 'cursor-wait' : ""
                            )}
                          >
                            <img src={navSettingsIcon} className='inline me-2 btn-icon' alt='Settings' />{setting}
                          </p>
                        </Menu.Item>
                        <Divider className='m-0 border-gray-200' />
                        <Menu.Item>
                          <p
                            onClick={() => handleClick(logOut)}
                            className={classNames(
                              'block px-4 py-2 text-sm cursor-pointer cu text-red-600 hover:text-red-600',
                              isLoading ? 'cursor-wait' : ""
                            )}
                          >
                            <img src={navLogoutIcon} className='inline me-2 btn-icon' alt='Logout' />{logOut}
                          </p>
                        </Menu.Item>
                      </Menu.Items>
                    </Transition>
                  </Menu>
                </Tooltip>
              </>
            }
          </div>
        </div>
      </div>
    </Disclosure>
  )
}